import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadWahlErgebnis } from "./wahlen-actions.js";
import { wahlenService } from "../service/wahlen-service.js";

/**
 * `switchMap`: Die Auswahl auf der Detailseite wechselt schnell — wer drei
 * Arten durchklickt, soll die zuletzt gewählte sehen, nicht die zuletzt
 * eingetroffene.
 */
export const loadWahlErgebnisEffect = actions$.pipe(
  ofType(loadWahlErgebnis.action),
  switchMap(({ payload: id }) =>
    wahlenService.ladeErgebnis(id).pipe(
      map((e) => loadWahlErgebnis.success(e)),
      catchError((err) => of(loadWahlErgebnis.fail(err))),
    ),
  ),
);

export const wahlenEffects = [loadWahlErgebnisEffect];
